import { modifyState, getState } from '~src/state';
import { isLoggedUserGlobalEditor } from '~src/user';
import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlEdges } from '~graphql/utils';
import {
  GET_EDITOR_BACKGROUNDS,
  GET_EDITOR_BACKGROUNDS_BY_TAG,
  GET_EDITOR_BACKGROUNDS_BY_TAG_AND_ORIENTATION,
  GET_EDITOR_BACKGROUNDS_DEFAULT,
  GET_EDITOR_BACKGROUNDS_DEFAULT_BY_TAG,
  GET_EDITOR_BACKGROUNDS_DEFAULT_BY_TAG_AND_ORIENTATION,
} from '../queries/editorBackgrounds';
import { onSidebarSubTabChange } from '~src/observables/onSidebarSubTabChange';
import editorConfig from '~config/editorConfig';

let defaultAfterCursor = ''; // GraphQL pagination cursor
let afterCursor = ''; // GraphQL pagination cursor
let limit = 24;

export const fetchEditorBackgrounds = async ({
  editorBackgroundsDefaultAfterCursor,
  editorBackgroundsAfterCursor,
  forceFetch,
}) => {
  if (editorBackgroundsDefaultAfterCursor) {
    defaultAfterCursor = editorBackgroundsDefaultAfterCursor;
  } else {
    defaultAfterCursor = '';
  }
  if (editorBackgroundsAfterCursor) {
    afterCursor = editorBackgroundsAfterCursor;
  } else {
    afterCursor = '';
  }

  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const paramsDefault = {};
  const paramsCustom = {};

  let orientation;

  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');

  if (format) {
    if (format.orientation) {
      orientation = format.orientation;
    } else {
      orientation = format.editor_project_formats_default_pointer.orientation;
    }
  }

  if (formatDefault) {
    if (formatDefault.orientation) {
      orientation = formatDefault.orientation;
    } else {
      orientation =
        formatDefault.editor_project_formats_default_pointer.orientation;
    }
  }

  if (isGlobalEditor) {
    paramsDefault['isGlobal'] = true;
  }

  paramsDefault['orientation'] = orientation;
  paramsCustom['orientation'] = orientation;

  if (currentTag) {
    paramsDefault.tag = currentTag;
    paramsCustom.tag = currentTag;
  }

  paramsDefault['limit'] = limit;
  paramsCustom['limit'] = limit;

  if (defaultAfterCursor) {
    paramsDefault['after'] = defaultAfterCursor;
  }

  if (afterCursor) {
    paramsCustom['after'] = afterCursor;
  }

  try {
    const graphQlClient = await getGraphQlClient();

    const promiseDefault = graphQlClient.query({
      fetchPolicy: forceFetch ? 'network-only' : 'cache-first',
      variables: paramsDefault,
      query:
        currentTag && currentTag === 'NO_TAG'
          ? GET_EDITOR_BACKGROUNDS_DEFAULT
          : currentTag === editorConfig.magicFrameTag
          ? GET_EDITOR_BACKGROUNDS_DEFAULT_BY_TAG
          : GET_EDITOR_BACKGROUNDS_DEFAULT_BY_TAG_AND_ORIENTATION,
    });

    const promiseCustom = graphQlClient.query({
      fetchPolicy: forceFetch ? 'network-only' : 'cache-first',
      variables: paramsCustom,
      query:
        currentTag && currentTag === 'NO_TAG'
          ? GET_EDITOR_BACKGROUNDS
          : currentTag === editorConfig.magicFrameTag
          ? GET_EDITOR_BACKGROUNDS_BY_TAG
          : GET_EDITOR_BACKGROUNDS_BY_TAG_AND_ORIENTATION,
    });

    const responses = await Promise.all([promiseDefault, promiseCustom]);

    modifyState(
      `${currentTag}.editorBackgroundsDefaultAfterCursor`,
      responses[0].data.editor_backgrounds_defaults.pageInfo.endCursor
    );
    modifyState(
      `${currentTag}.editorBackgroundsDefaultHasNextPage`,
      responses[0].data.editor_backgrounds_defaults.pageInfo.hasNextPage
    );

    modifyState(
      `${currentTag}.editorBackgroundsAfterCursor`,
      responses[1].data.findEditorBackgrounds.pageInfo.endCursor
    );
    modifyState(
      `${currentTag}.editorBackgroundsHasNextPage`,
      responses[1].data.findEditorBackgrounds.pageInfo.hasNextPage
    );

    const activeTab = getState('activeSidebarSubTab', 'backgrounds-default');
    onSidebarSubTabChange(activeTab);

    let items = [];

    items = items.concat(
      unmarshalGraphqlEdges(responses[0].data.editor_backgrounds_defaults).edges
    );

    items = items.concat(
      unmarshalGraphqlEdges(responses[1].data.findEditorBackgrounds).edges
    );

    items = items.map((edge) => {
      edge.tags = unmarshalGraphqlEdges(edge.tags).edges;
      return edge;
    });

    return {
      backgrounds: {
        allowNew: false,
        items,
      },
    };
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
